// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import Vuex from 'vuex'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Lazyload } from 'vant'
import './utils/rem'
import https from '@/utils/https'

Vue.use(Vant);
Vue.use(Lazyload);
Vue.config.productionTip = false;
Vue.prototype.$https=https;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  created(){
    let userInfo=localStorage.getItem("guanai_userInfo");
    userInfo=JSON.parse(userInfo) ;
    if(userInfo){
      this.$store.commit("LOGIN",userInfo);
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js